// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mj4Z","col":"styles_col__1b6h6"};